var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 105,
    viewBox: "0 0 152 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.267 75.564L64.127 62.514L52.177 54.874L49.207 64.754L60.287 77.224L70.257 75.564H70.267Z",
    fill: "#FBFFCA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2079 64.7637L46.5579 75.1737C46.0679 77.0837 47.6679 78.8837 49.6179 78.6237L60.2979 77.2337L49.2179 64.7637H49.2079Z",
    fill: "#7A5FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5277 33.0334L85.8677 24.9434L52.1777 54.8834L70.2677 75.5634L104.118 45.4834L97.5277 33.0334Z",
    fill: "#7A5FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.12 45.4818L85.8751 24.9461L91.6463 19.8186C94.0161 17.7131 97.6584 17.9283 99.7639 20.298L110.378 32.2441C112.483 34.6139 112.268 38.2563 109.898 40.3617L104.127 45.4893L104.12 45.4818Z",
    fill: "#F875B4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPencil);
export default __webpack_public_path__ + "static/media/card_pencil.7d2aff91abcde31b24dc8f6f8ceefb19.svg";
export { ForwardRef as ReactComponent };